module.exports = __webpack_public_path__ + "img/6_of_Diamonds.svg.0d6a0677.png";